import { FC } from 'react';
import { observer } from 'mobx-react';
import { Card, Text } from '@servicetitan/anvil2';
import { TitleValue, TitleWithValueComponent } from './common/title-value';
import { getFString } from '../../utils/get-f-string';
import classNames from 'classnames';
import { CalculateSuperHeatResponseDto } from '../../models/calculate-super-heat.response.dto';

export const CalculateSuperHeatAnswer: FC<{
    data: CalculateSuperHeatResponseDto;
    className?: string;
}> = observer(({ data, className }) => {
    return (
        <Card className={classNames('w-100-i', className)}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', rowGap: 12 }}>
                <TitleValue title="Superheat" value={getFString(data.super_heat)} />
                <TitleValue title="saturation Temperature" value={getFString(data.dew_temp)} />
                <TitleWithValueComponent
                    title="Target superheat Range"
                    value={
                        <ul style={{ paddingLeft: 16, margin: 8 }}>
                            <li>
                                <Text size="small">5 - 15° F for TXV systems</Text>
                            </li>
                            <li>
                                <Text size="small">10 - 20° F for fixed orifice</Text>
                            </li>
                        </ul>
                    }
                />
            </div>
        </Card>
    );
});
